export default __webpack_public_path__ + "static/media/russiantblewindows2.f143c9b8.webp";